import { guid } from '@/mixins/guid';

export function colShape(dynColClass = '') {
  return () => ({
    _id: guid.methods.guid(),
    bgImg: null,
    mediaQueries: [
      {
        property: 'width',
        unit: '%',
        desktop: 'default',
        tablet: 'default',
        mobile: '100',
      },
    ],
    droplets: [],
    type: 'droplet.columns.column',
    pageLink: false,
    dynColClass,
  });
}

export function getColClass(len = 2) {
  return `col-${12 / len}`.replace(/\./g, '-');
}



// WEBPACK FOOTER //
// ./src/global-view/editor/droplets/columns/utils.js